import { render, staticRenderFns } from "./ResourceExtUI.vue?vue&type=template&id=3bf9caa8&"
import script from "./ResourceExtUI.vue?vue&type=script&lang=js&"
export * from "./ResourceExtUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports